import { lazy } from 'react';
import { retry } from '../../../config/utils';

const UploadLoan = lazy(() => retry(()=> import(/* webpackChunkName: "PartnerUploadLoan" */ "./index")));

export default UploadLoan;